import { render, staticRenderFns } from "./share_earn.vue?vue&type=template&id=571a5709&scoped=true&"
import script from "./share_earn.vue?vue&type=script&lang=js&"
export * from "./share_earn.vue?vue&type=script&lang=js&"
import style0 from "./share_earn.vue?vue&type=style&index=0&id=571a5709&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571a5709",
  null
  
)

export default component.exports